Alerts = require 'app/scripts/views/lib/alerts'
{ Analytics, getScreenFromUrl } = require '@trello/atlassian-analytics'
ApiAjax = require 'app/scripts/network/api-ajax'
ApiError = require 'app/scripts/network/api-error'
ApiPromise = require 'app/scripts/network/api-promise'
ArchivableMixin = require 'app/scripts/lib/archivable-mixin'
Auth = require 'app/scripts/db/auth'
Backgrounds = require 'app/scripts/data/backgrounds'
Batcher = require 'app/scripts/network/rpc/batcher'
{ BoardPluginList } = require 'app/scripts/models/collections/BoardPluginList'
BoardState = require 'app/scripts/view-models/board-state'
CardComposer = require 'app/scripts/view-models/card-composer'
CardFilter = require 'app/scripts/view-models/card-filter'
{ getBoardInvitationLinkUrl, getBoardUrl, getBoardShortUrl } = require 'app/scripts/controller/urls'
CustomFieldList = require 'app/scripts/models/collections/custom-field-list'
{ dontUpsell } = require '@trello/config'
{ featureFlagClient } = require '@trello/feature-flag-client'
Hearsay = require 'hearsay'
IdCache = require 'app/scripts/db/id-cache'
Label = require 'app/scripts/models/label'
LabelList = require 'app/scripts/models/collections/label-list'
LegacyPowerUps = require 'app/scripts/data/legacy-power-ups'
LimitMixin = require 'app/scripts/lib/limit-mixin'
ListComposer = require 'app/scripts/view-models/list-composer'
MembershipModel = require 'app/scripts/models/internal/membership-model'
ModelWithPersonalPreferences = require 'app/scripts/models/internal/model-with-personal-preferences'
{ OrganizationFeature } = require('@trello/product-features')
Payloads = require 'app/scripts/network/payloads'
PluginDataList = require 'app/scripts/models/collections/plugin-data-list'
Promise = require 'bluebird'
Util = require 'app/scripts/lib/util'
actionFilterFromString = require 'app/scripts/lib/util/action-filter-from-string'
xtend = require 'xtend'
_ = require 'underscore'
{ mixin } = require 'app/scripts/lib/mixin_DO_NOT_USE'
l = require 'app/scripts/lib/localize'
moment = require 'moment'
{ removeBoard } = require 'app/scripts/views/onboarding/storage'
{ trackUe, Noun, Verb } = require '@trello/analytics'

BUTLER_POWER_UP_ID = require 'app/scripts/data/butler-id'
CALENDAR_POWER_UP_ID = LegacyPowerUps.calendar
CUSTOM_FIELDS_ID = require('@trello/config').customFieldsId
LIST_LIMITS_POWER_UP_ID = require('@trello/config').listLimitsPowerUpId
MAP_POWER_UP_ID = require('@trello/config').mapPowerUpId
WELCOME_BOARD_THRESHOLD = 10000

class Board extends ModelWithPersonalPreferences
  mixin MembershipModel, ArchivableMixin, LimitMixin, @

  typeName: 'Board'
  urlRoot: '/1/boards'
  initialize: ->
    super

    @listenForPermChange()
    @cacheShortLink()

  @lazy
    boardPluginList: ->
      new BoardPluginList([], { board: @ }).syncCache @modelCache, ['idBoard'], (boardPlugin) =>
        boardPlugin.get('idBoard') == @id
    listList: ->
      # Dependency required at call site to avoid import cycles, do not lift to top of module
      ListList = require 'app/scripts/models/collections/list-list'
      new ListList(null, { board: @ })
      .owner(@)
      .syncCache @modelCache, ['idBoard', 'closed'], (list) =>
        list.get('idBoard') == @id && list.isOpen()
    invitationList: ->
      # Dependency required at call site to avoid import cycles, do not lift to top of module
      { BoardInvitationList } = require 'app/scripts/models/collections/BoardInvitationList'
      new BoardInvitationList([], { @modelCache, board: @ })
    checklistList: ->
      # Dependency required at call site to avoid import cycles, do not lift to top of module
      ChecklistList = require 'app/scripts/models/collections/checklist-list'
      new ChecklistList([], { @modelCache, board: @ })
    customFieldList: ->
      new CustomFieldList()
      .syncCache @modelCache, ['idModel'], (customField) =>
        customField.get('idModel') == @id
    labelList: ->
      new LabelList()
      .syncCache @modelCache, ['idBoard'], (label) =>
        label.get('idBoard') == @id
    memberList: ->
      # Dependency required at call site to avoid import cycles, do not lift to top of module
      MemberList = require 'app/scripts/models/collections/member-list'
      new MemberList().syncModel(@, 'memberships', { fxGetIds: (memberships) -> _.pluck(memberships, 'idMember') })
    adminList: ->
      # Dependency required at call site to avoid import cycles, do not lift to top of module
      MemberList = require 'app/scripts/models/collections/member-list'
      new MemberList().syncModel(@, 'memberships', {
        fxGetIds: (memberships) =>
          # Because a member could be the admin of a premium org (and thus be
          # an implicit admin of this board) but not an admin on the board, we
          # need to also check if the member is a premium org admin.  This check
          # needs to be done directly since getExplicitMemberType may return
          # that the member is an admin due to its board membership info not
          # being updated yet
          adminMemberships = _.filter memberships, (membership) =>
            member = @modelCache.get('Member', membership.idMember)
            return membership.memberType == 'admin' || (member? && @getOrganization()?.isPremOrgAdmin(member))

          _.pluck(adminMemberships, 'idMember')
      })
    pluginDataList: ->
      new PluginDataList([], {
        scopeModel: @
      }).syncCache @modelCache, [], (pluginData) =>
        pluginData.get('idModel') == @id && pluginData.get('scope') == 'board'
    filter: ->
      new CardFilter(@, { @modelCache })
    composer: ->
      new CardComposer(null, { board: @, @modelCache })
    listComposer: ->
      new ListComposer(@, { @modelCache })
    viewState: ->
      new BoardState(null, { @modelCache, board: @ })

  isVisibleAction: (action) ->
    @_actionFilter ?= actionFilterFromString(Payloads.boardActions)
    @_actionFilter(action)

  cacheShortLink: ->
    @waitForAttrs @, ['id', 'shortLink'], ({ id, shortLink }) ->
      IdCache.setBoardId(shortLink, id)

  hasCapacity: (item) ->
    if item.getList?
      # Card
      list = item.getList()
      !@isOverLimit('cards', 'totalPerBoard') &&
      !@isOverLimit('cards', 'openPerBoard')
    else
      # List
      !@isOverLimit('lists', 'totalPerBoard') &&
      !@isOverLimit('lists', 'openPerBoard')

  close: (next, removeInspirationBoard = true) ->
    if removeInspirationBoard
      removeBoard(@get('id'))

    @update({ closed: true }, next)

    # Optimistically attempt to update free board limit
    @getOrganization()?.incrementFreeBoardLimitCount(-1)

    return

  reopen: ({ newBillableGuests, keepBillableGuests } = {}) ->
    newBillableGuests ?= []
    keepBillableGuests ?= false

    # If we are keeping billable guests upon re-opening, invoke the attribute
    # specific endpoint with the keepBillableGuests param to let server know not to drop
    # them
    if keepBillableGuests
      @set 'closed', false
      @api {
        type: 'put'
        method: "closed?value=false&keepBillableGuests=true"
      }
      return

    # Otherwise, if necessary, optimistically remove any billable guests
    if newBillableGuests.length > 0
      @set 'memberships', _.reject(
        @get('memberships'),
        (membership) -> _.some(newBillableGuests, (guest) -> membership.idMember == guest.id)
      )

    @update({ closed: false })

    # Optimistically attempt to update free board limit
    @getOrganization()?.incrementFreeBoardLimitCount(1)

    return

  markAsViewed: ->
    if !Auth.isLoggedIn()
      return
    # Set day last viewed for invite acceptance notification
    @set 'previousDateLastView', @get('dateLastView')
    @set {
      dateLastView: new Date().toISOString()
    }, { broadcast: true }

    ApiAjax
      url: "#{@urlRoot}/#{@id}/markAsViewed"
      type: 'post'
      background: true

  subscribe: (subscribed, next) ->
    return if subscribed == @get('subscribed')
    @update { subscribed }, next

    return

  isStarred: ->
    Auth.me().boardStarList.getBoardStar(@id)?

  hasUnseenActivity: ->
    dtView = @get('dateLastView')
    dtActivity = @get('dateLastActivity')
    dtView? && dtActivity? && dtView < dtActivity

  daysUntilPluginsDisable: ->
    if (date = @get('datePluginDisable'))?
      moment(date).diff(moment(), 'days')
    else
      null

  isLessActive: ->
    dtLastActivity = @get('dateLastActivity') ? new Date(Util.idToDate(@id))
    sixMonthsAgo = moment().subtract(6, 'months')
    sixMonthsAgo.isAfter(dtLastActivity)

  getAvailableRoles: ->
    if @hasObservers()
      ['admin', 'normal', 'observer']
    else
      ['admin', 'normal']

  hasObservers: ->
    @getOrganization()?.isFeatureEnabled("observers")

  hasAdvancedChecklists: ->
    @isFeatureEnabled(OrganizationFeature.AdvancedChecklists)

  upsellAdvancedChecklists: ->
    @editable() && !dontUpsell && !@hasAdvancedChecklists()

  isFeatureEnabled: (feature) ->
    @get('premiumFeatures')?.includes(feature)

  getPermLevel: -> @getPref('permissionLevel')

  _normalizePref: (pref) ->
    if pref == 'none'
      'disabled'
    else
      pref

  getCommentPerm: ->
    @_normalizePref @get('prefs').comments

  getInvitePerm: ->
    @_normalizePref @get('prefs').invitations

  toJSON: (opts = {}) ->
    data = super

    if opts.org
      organization = @getOrganization()
      if organization?
        data.hasOrg = true
        data.org = organization.toJSON({ url: true })

    if opts.url
      data.url ?= getBoardUrl(@)

    if opts.shortUrl
      data.shortUrl ?= getBoardShortUrl(@)

    data

  calcPos: (index, list) ->
    Util.calcPos(index, @listList, list, (list) -> list.isOpen())

  getCard: (idCard) ->
    if Util.isShortId(idCard)
      @modelCache.findOne('Card', 'idShort', Number(idCard))
    else
      @modelCache.get('Card', idCard)

  getList: (idList) -> @listList.get(idList)

  getUrl: -> getBoardUrl(@)

  getChecklist: (idChecklist) -> @modelCache.get('Checklist', idChecklist)

  getBoardInvitation: (idBoardInvitation) -> @invitationList.get(idBoardInvitation)

  getCheckItem: (idCheckItem) ->
    for checklist in @checklistList.models
      checkItem = checklist?.checkItemList?.get(idCheckItem)
      if (checkItem)
        return checkItem

  editable: ->
    me = Auth.me()
    me && (@editableByMember(me) || @isEditableByTeamMember())

  isEditableByTeamMember: ->
    org = @getOrganization()
    if !org?
      return false

    me = Auth.me()

    if @isObserver(me)
      return false

    isOrgMember = org.isMember(me)
    return @isPremOrgAdmin(me) || (@allowsSelfJoin() && isOrgMember)

  requestJoinBoard: (callback) ->
    if @isEditableByTeamMemberAndIsNotABoardMember()
      @joinBoard(callback)
      Alerts.show('woohoo-you-are-now-a-member-of-this-board', 'info', 'join-board', 4000)
    else
      callback()

  isEditableByTeamMemberAndIsNotABoardMember: ->
    @isEditableByTeamMember() && !@getMembershipFor(Auth.me())?

  editableByMember: (member) -> @isMember(member)

  isMember: (member) ->
    @getMemberType(member) in ['virtual', 'normal', 'admin']

  isGuest: (member) ->
    @getMemberType(member) in ['virtual', 'normal', 'admin', 'observer'] &&
    @hasOrganization() &&
    !member.getSortedOrgs().find((org) => org.get('id') == @get('idOrganization'))

  getMembershipCount: ->
    @get('membershipCounts')?.active ? @get('memberships')?.length ? 1

  getStarCount: (type) ->
    @get('starCounts')?[type] ? 0

  getIdTags: ->
    @get('idTags') ? []

  owned: ->
    me = Auth.me()
    me && @ownedByMember(me)

  ownedByMember: (member) ->
    @getMemberType(member) == 'admin'

  allowsSelfJoin: ->
    @getPref('selfJoin') ? false

  isTemplate: ->
    if !@getPref('isTemplate')
      return false
    #  Any public boards can be templates
    else if @isPublic() || @isFeatureEnabled('privateTemplates')
      return true

    return false

  canDelete: ->
    org = @getOrganization()
    @owned() && (!org || org.canDeleteBoard(@))

  canJoin: ->
    org = @getOrganization()
    if !org? && !@get('idEnterprise')?
      return false

    me = Auth.me()

    # We check for the existence of a membership; the might have a
    # memberType of admin due to being a BC admin
    if @getMembershipFor(me)? || @isObserver(me)
      return false

    isOrgMember = org && org.isMember(me)
    return @isPremOrgAdmin(me) || (@allowsSelfJoin() && isOrgMember) || (@isEnterpriseBoard() && @getEnterprise()?.isAdmin(me))

  canInviteMembers: ->
    if !@getOrganization()? && !@getPref('canInvite')
      return false

    if @get('prefs')?.invitations == 'admins'
      typeAllowedtoInvite = 'admin'

    else if @get('prefs')?.invitations == 'members'
      typeAllowedtoInvite = 'normal'

    @getMemberType(Auth.me()) == 'admin' || typeAllowedtoInvite == @getMemberType(Auth.me())

  canUpsellToEnterprise: ->
    me = Auth.me()

    !me.isDismissed('enterprise-upsell-board-sidebar') &&
    me.enterpriseList?.length == 0 &&
    @hasOrganization() &&
    !@hasEnterprise() &&
    @getOrganization()?.get('memberships').length >= 20

  compareMemberType: (memberA, memberB, opts) ->
    Util.compareMemberType(@, memberA, memberB, opts)

  isMemberPublic: (member) ->
    @getMemberType(member) == 'public'

  isMemberOrg: (member) ->
    @getMemberType(member) == 'org'

  isMemberObserver: (member) ->
    @getMemberType(member) == 'observer'

  memberMatchesSetting: (member, setting) ->
    switch @getPref(setting)
      when 'public'
        Auth.isLoggedIn()
      when 'org'
        @isMember(member) || @isMemberOrg(member) || @isMemberObserver(member)
      when 'observers'
        @isMember(member) || @isMemberObserver(member)
      when 'members'
        @isMember(member)
      when 'admins'
        @ownedByMember(member)
      else # 'none'
        false

  isPowerUpEnabled: (name) ->
    # in some cases we don't *know* about a board's power ups, because we've
    # loaded it (for example) on the "my cards" page, and we want to keep
    # data down to minimum. But we also don't want to pretend like it's empty,
    # since that could be weirder, so we just don't have that field at all.
    # This means that we don't actually *know* if this power up is enabled, so
    # we default to false when we don't have enough information to answer.
    powerUps = @get('powerUps')
    powerUps? && name in powerUps \
        || (name == 'calendar' && LegacyPowerUps.calendar in @idPluginsEnabled()) \
        || (name == 'cardAging' && LegacyPowerUps.cardAging) in @idPluginsEnabled() \
        || (name == 'voting' && LegacyPowerUps.voting) in @idPluginsEnabled()

  isButlerCore: ->
    # almost a tautology, since for Butler to be core, by definition Trello server
    # would have served us a boardPlugin record meaning it would be enabled
    if !@isPluginEnabled(BUTLER_POWER_UP_ID)
      return false

    idEnterprise = @getEnterprise()?.get('id')
    if idEnterprise && idEnterprise in featureFlagClient.get('butler.enterprise-butler-core-blacklist', [])
      return false
    return true

  powerUpsCount: ->
    # Things in the powerUps list are grandfathered and don't count against the limit
    @boardPluginList.filter((boardPlugin) -> !boardPlugin.isButler()).length

  limitedPowerUpsCount: ->
    # promotional plugins don't count towards the users Power-Up limit on this board
    @boardPluginList.filter((boardPlugin) -> !boardPlugin.get('promotional')).length

  canEnableAdditionalPowerUps: ->
    Auth.isLoggedIn() && @limitedPowerUpsCount() < Auth.me().getPowerUpsLimit()

  isPluginEnabled: (idPlugin) ->
    @boardPluginList.any (boardPlugin) -> boardPlugin.get('idPlugin') == idPlugin

  isCustomFieldsEnabled: ->
    @isPluginEnabled(CUSTOM_FIELDS_ID)

  isListLimitsPowerUpEnabled: ->
    @isPluginEnabled(LIST_LIMITS_POWER_UP_ID)

  isMapPowerUpEnabled: ->
    @isPluginEnabled(MAP_POWER_UP_ID)

  enablePlugin: (idPlugin, promotional = false) ->
    new Promise (resolve, reject) =>
      @boardPluginList.create { idPlugin, promotional }, {
        success: resolve
        error: (status, textStatus) =>
          reject({ status, textStatus })
      }

      if featureFlagClient.get('remarkable.track-bc-features', false)
        idOrganization = @get('idOrganization')
        if idOrganization
          trackUe
            category: Noun.BUSINESS_CLASS_FEATURE
            verb: Verb.ENABLES
            directObj: Noun.POWER_UP
            context:
              organizationId: idOrganization
              powerUpId: idPlugin
              requiredBC: false

          Analytics.sendTrackEvent
            action: 'enabled'
            actionSubject: 'powerUp'
            objectType: 'powerUp'
            objectId: idPlugin
            containers:
              board:
                id: @id
              organization:
                id: idOrganization
            source: 'createBoardModal'
            attributes:
              isBCFeature: true
              requiredBC: false

  disablePlugin: (idPlugin) ->
    boardPlugin = @boardPluginList.find (boardPlugin) -> boardPlugin.get('idPlugin') == idPlugin
    boardPlugin.destroy()

  canVote: (member) ->
    @memberMatchesSetting(member, 'voting') || (@isEditableByTeamMember() && @getPref('voting') != 'disabled')

  canComment: (member) -> @memberMatchesSetting(member, 'comments') || (@isEditableByTeamMember() && @getPref('comments') != 'disabled')
  canInvite: (member) -> @memberMatchesSetting(member, 'invitations')

  prefNames: ['permissionLevel', 'voting', 'comments', 'invitations', 'selfJoin', 'background', 'cardAging', 'calendarFeedEnabled']
  myPrefNames: ['showSidebar', 'showSidebarMembers', 'showSidebarBoardActions', 'showSidebarActivity', 'emailKey', 'idEmailList', 'emailPosition', 'calendarKey', 'fullEmail']

  isPublic: -> @getPref('permissionLevel') == 'public'
  isPrivate: -> @getPref('permissionLevel') == 'private'

  getIdBoardMems: -> _.map(@memberList.models, (member) => member.id )

  getOrganization: ->
    @modelCache.get('Organization', @get('idOrganization'))

  getEnterprise: ->
    if @get('idEnterprise')
      @modelCache.get('Enterprise', @get('idEnterprise'))
    else
      @getOrganization()?.getEnterprise()

  # We can't necessarily see the org
  hasOrganization: ->
    @get('idOrganization')

  hasEnterprise: ->
    # Directly owned by an enterprise
    if @get('idEnterprise')?
      return true

    # Owned by an enterprise via an org
    org = @getOrganization()
    org?.get('idEnterprise')? && !org?.isBCPO()

  isOrgAtOrOverFreeBoardLimit: ->
    @getOrganization()?.isAtOrOverFreeBoardLimit() || false

  snoopOrganization: ->
    @snoop('idOrganization').map => @getOrganization()

  orgMembersAvailable: ->
    organization = @getOrganization()
    _.chain organization.memberList.filter (member) =>
      !organization.isDeactivated(member)
    .difference @memberList.models
    .value()

  joinBoard: (next) ->
    me = Auth.me()
    isPremOrgAdmin = @isPremOrgAdmin(me)
    memberType = if isPremOrgAdmin then 'admin' else 'normal'

    # Fake out idBoards/idPremOrgsAdmin client-side, so we don't have to
    # wait for the response back from the server
    me.set('idBoards', me.get('idBoards').concat(@id))
    if isPremOrgAdmin
      me.set('idPremOrgsAdmin', (me.get('idPremOrgsAdmin') ? []).concat(@id))

    @addMember me, memberType, next

  addMember: (member, [memberType, invitationMessage]..., next) ->
    memberType ?= 'normal'
    id = member.id
    email = member.get 'email'
    data = {
      type: memberType,
      invitationMessage: invitationMessage
      allowBillableGuest: true
    }

    # [TRELP-1453]
    # If we have the email use that instead of the id, this should
    # only be the case when the user has manually entered a full valid
    # email address and not searched. If we have an email we also don't
    # want to allow the server to accept an unconfirmed member directly
    # to the board this protects against a potential phishing attack
    if email
      id = ''
      data.email = email
    else
      data.acceptUnconfirmed = true

    @memberList.add(member)
    @api {
      type: 'put'
      method: "members/#{ id }"
      data
    }, next

    @set('memberships', @get('memberships').concat({ idMember: member.id, memberType: 'normal' }))

    Analytics.sendTrackEvent
      action: 'added'
      actionSubject: 'member'
      actionSubjectId: member.id
      source: getScreenFromUrl()
      containers:
        board:
          id: @get('id')
        organization:
          id: @get('idOrganization')
      attributes:
        addedTo: 'board'
        confirmed: !!member.get('confirmed')
        memberType: memberType

    if featureFlagClient.get('remarkable.track-bc-features', false)
      if memberType == 'observer' && (idOrganization = @get('idOrganization'))?
        trackUe
          category: Noun.BUSINESS_CLASS_FEATURE
          verb: Verb.ADDS
          directObj: Noun.OBSERVER
          context:
            organizationId: idOrganization
            requiredBC: true

        Analytics.sendTrackEvent
          action: 'added'
          actionSubject: 'observer'
          containers:
            board:
              id: @id
            organization:
              id: idOrganization
          source: 'boardScreen'
          attributes:
            isBCFeature: true
            requiredBC: true


  removeMember: (member) ->
    @memberList.removeMembership(member)
    @set 'memberships', _.reject(@get('memberships'), (membership) -> membership.idMember == member.id)

  changeMemberRole: (member, opts) ->
    if featureFlagClient.get('remarkable.track-bc-features', false)
      if opts?.type == 'observer' && (idOrganization = @get('idOrganization'))?
        trackUe
          category: Noun.BUSINESS_CLASS_FEATURE
          verb: Verb.ADDS
          directObj: Noun.OBSERVER
          context:
            organizationId: idOrganization
            requiredBC: true

        Analytics.sendTrackEvent
          action: 'added'
          actionSubject: 'observer'
          containers:
            board:
              id: @id
            organization:
              id: idOrganization
          source: 'boardScreen'
          attributes:
            isBCFeature: true
            requiredBC: true

    # Can't use super on a mixin
    MembershipModel::changeMemberRole.apply(@, arguments)

  getObserverList: -> member for member in @memberList.models when @isObserver(member)

  filterLabels: (term) ->
    termRe = ///^#{Util.escapeForRegex(term)}///

    filteredLabels = []

    _.chain(@getLabels())
      .filter (label) ->
          label.get('name')?.toLowerCase().indexOf(term) > -1 ||
          label.get('color')?.toLowerCase().indexOf(term) == 0 ||
          label.get('color') == Label.colors[parseInt(term) - 1]
      .value()

  labelForColor: (color) ->
    _.chain(@getLabels())
      .filter (label) -> label.get('color') == color
      .first()
      .value()

  labelsForColors: ->
    _.chain(@getLabels())
      .groupBy (label) -> label.get('color')
      .value()

  createLabel: (name, color) ->
    label = _.find @getLabels(), (label) ->
      label.get('name') == name && label.get('color') == color
    if !label
      createdLabel = @labelList.create(
        { name, color: color ? '' }
        {
          url: "/1/board/#{@id}/labels/",
          error: =>
            # The label is optimisitically added.
            # If the add fails, remove the label
            @labelList.remove(createdLabel)
        }
      )
    return

  labelColors: -> Label.colors

  getLabels: ->
    @labelList.models.sort(Label.compare)

  _generateKey: (type) ->
    @api
      type: 'post'
      method: "#{type}Key/generate"

  generateEmailKey: ->
    @_generateKey 'email'

  generateCalendarKey: ->
    @_generateKey 'calendar'

  openCards: ->
    _.flatten(list.openCards().models for list in @listList.models)

  listenForPermChange: ->
    if !Auth.isLoggedIn()
      return # nothing to listen for

    lastPermState = @getViewPermState(Auth.me())
    lastOwned = @owned()

    checkChange = @callOnceAfter =>
      currentPermState = @getViewPermState(Auth.me())
      if currentPermState != lastPermState
        lastPermState = currentPermState
        @trigger('permChange', currentPermState)

      currentOwned = @owned()
      if currentOwned != lastOwned
        lastOwned = currentOwned
        @trigger('ownedChange', currentOwned)
      return

    @listenTo Auth.me().boardList, 'add remove reset', checkChange
    @listenTo Auth.me().organizationList, 'add remove reset', checkChange
    @listenTo @memberList, 'add remove reset', checkChange
    @listenTo @, 'change:memberships change:prefs.permissionLevel', checkChange

  getViewPermState: (member) ->
    if @isObserver(member)
      'observer'
    else if @getMemberType(member) in ['normal', 'admin']
      'member'
    else if Util.hasValidInviteTokenFor(@)
      'inviteToken'
    else if @getOrganization()?.isMember(member) && @getPref('permissionLevel') == 'org'
      'org'
    else if @getPref('permissionLevel') == 'public'
      'public'
    else if @getEnterprise()?.canViewEnterpriseVisibleBoard(member) && @getPref('permissionLevel') == 'enterprise'
      'enterprise'
    else
      'none'

  getClientBackgroundColor: (background) ->
    Backgrounds[background]?.color ? Backgrounds['blue'].color

  dataForLabel: (label) ->
    label.toJSON()

  isViewableBy: (member) ->
    @getViewPermState(member) != 'none'

  toggleTag: (idTag) ->
    @toggle('idTags', idTag, idTag !in @getIdTags())

  setPluginData: (idPlugin, visibility, data) ->
    @pluginDataList.upsert(idPlugin, visibility, data)

  setPluginDataByKey: (idPlugin, scope, visibility, key, val) ->
    @pluginDataList.setPluginDataByKey(idPlugin, scope, visibility, key, val)

  getPluginData: (idPlugin) ->
    xtend @getOrganization()?.getPluginData(idPlugin), @pluginDataList.dataForPlugin(idPlugin)

  getPluginDataByKey: (idPlugin, scope, visibility, key, defaultVal) ->
    @pluginDataList.getPluginDataByKey(idPlugin, scope, visibility, key, defaultVal)

  snoopPluginData: (idPlugin) ->
    orgPluginData = @snoopOrganization()
    .map (org) ->
      if org?
        org.snoopPluginData(idPlugin)
      else
        Hearsay.const null
    .latest()

    boardPluginData = @pluginDataList.snoopDataForPlugin(idPlugin)

    Hearsay.combine orgPluginData, boardPluginData
    .map (entries) -> xtend entries...

  clearPluginData: (idPlugin) ->
    boardData = @pluginDataList.for(idPlugin, 'private')
    if boardData?
      boardData.destroy()
    orgData = @getOrganization()?.pluginDataList.for(idPlugin, 'private')
    if orgData?
      orgData.destroy()

  idPluginsEnabled: ->
    @boardPluginList.pluck('idPlugin')

  snoopIdPluginsEnabled: ->
    Hearsay.combine(@boardPluginList.snoop())
    .map ([boardPluginList]) ->
      boardPluginList.pluck('idPlugin')

  invitationUrl: (secret) ->
    getBoardInvitationLinkUrl(secret)

  startDelete: ->
    @_isDeleting = true
    @trigger 'deleting'

    # This *starts* the delete, but it may take a while for it to actually
    # be deleted
    ApiPromise
      method: 'delete'
      url: @url()
    .then =>
      new Promise (resolve) =>
        checkBoard = =>
          ApiPromise
            url: @url()
            fields: ''
          .then =>
            setTimeout checkBoard, 500
          .catch ApiError.NotFound, =>
            resolve()
          .done()

        checkBoard()
    .then =>
      @modelCache.remove(@)
    .return()

  isDeleting: ->
    @_isDeleting

  isOrgBoard: ->
    # We consider it to be an org board if it belongs to an organization that
    # the member is part of
    idOrg = @getOrganization()?.id
    idOrg? && idOrg in Auth.me().get('idOrganizations')

  isEnterpriseBoard: ->
    # We consider it to be an enterprise board if one of the
    ## following is true:
    # - it has an `idEnterprise` set
    # - it belongs to an organization that belongs to an
    ## enterprise. We also check if it's a real enterprise,
    ## because we still have BCPO teams in the enterprises collection :/
    (@get('idEnterprise')?) ||
    (@getOrganization()?.isEnterprise() && @getOrganization()?.belongsToRealEnterprise())

  isWelcomeBoard: ->
    # creationMethod will always be demo for welcome boards
    # NOTE: we still use the old logic w/ threshold bc older welcome boards
    # don't have the creationMethod set
    @get('creationMethod') == 'demo' ||
      0 <= Util.idToDate(@get('id')) - Util.idToDate(Auth.myId()) < WELCOME_BOARD_THRESHOLD

  # Automatically creates a board for the user, without them explicity doing so
  # (without them pressing a button). This is normally a welcome/starter board.
  # The board will have any defaults that server has set.
  @assistedCreate: (name) ->
    new Promise (resolve, reject) =>
      initialData =
        name: name || l(['untitled board'])

      Auth.me().boardList.create initialData,
        requestData: _.extend({
          prefs_permissionLevel: 'private'
          prefs_selfJoin: true
          defaultLists: true
          creationMethod: 'automatic'
        }, initialData)
        success: (board) =>
          # this fixes an issue with idBoards not being updated at the time that
          # the board gets rendered and the client thinking the member is not on
          # the board
          if board.id !in (currentBoards = Auth.me().get('idBoards'))
            Auth.me().set('idBoards', currentBoards.concat(board.id))

          resolve(board)
        error: (err) -> reject(err)

  isFirstOwnedBoard: ->
    # Use a tighter threshold for boards created shortly after account creation,
    # including the skipBoardsPage board
    welcomeBoardThreshold = 1000
    # This is not quite the same as the check done in create board component
    # or view, but should be good enough for new users without waiting on
    # Auth.me().boardList being completely loaded since we have all the idBoards
    # that a member is on, including the current board.
    me = Auth.me()
    idBoards = me.get('idBoards')
    nonInvitedOrWelcomeBoardIds = _.filter idBoards, (idBoard) ->
    # Boards created after member was created
      !me.accountNewerThan(Util.idToDate(idBoard)) &&
        # Non-welcome boards
        Util.idToDate(idBoard) - Util.idToDate(Auth.myId()) > welcomeBoardThreshold
    nonInvitedOrWelcomeBoardIds.length == 1

  loadPlugins: ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'
    @availablePlugins = ModelLoader.loadBoardPlugins(@id, Auth.me()?.getLocale())

    if @isButlerCore()
      @availablePlugins = @availablePlugins.filter (plugin) -> plugin.id != BUTLER_POWER_UP_ID

    @availablePlugins

  getAvailablePlugins: ->
    @availablePlugins ?= @loadPlugins()

  hasCustomField: (type, name) ->
    @customFieldList.some (cf) ->
      cf.get('type') == type &&
      cf.get('name') == name

  getAttachmentRestrictions: ->
    if @getEnterprise()?
      @getEnterprise().getOrganizationPref('attachmentRestrictions')
    else
      getOrganization()?.getPref('attachmentRestrictions')

  getRestrictedAttachmentTypes: ->
    if @getEnterprise()?
      @getEnterprise().getRestrictedAttachmentTypes()
    else
      @getOrganization()?.getRestrictedAttachmentTypes()

  attachmentTypeRestricted: (attachmentType) ->
    @getEnterprise()?.attachmentTypeRestricted(attachmentType) || @getOrganization()?.attachmentTypeRestricted(attachmentType)

  attachmentUrlRestricted: (url) ->
    @getEnterprise()?.attachmentUrlRestricted(url) || @getOrganization()?.attachmentUrlRestricted(url)

  canRemoveMember: (member) ->
    @getMembershipFor(member) && (!@ownedByMember(member) || (@ownedByMember(member) && @adminList.length > 1))

  getNewBillableGuests: ->
    if !Auth.isLoggedIn()
      return Promise.resolve([])

    org = @getOrganization()
    if org?.isPO() && org?.isBusinessClass()
      response = {}
      batcher = new Batcher()
      [
        "/1/organizations/#{org.id}/newBillableGuests/#{@id}"
        "/1/organizations/#{org.id}?fields=availableLicenseCount"
      ].map (url) ->
        batcher.request(url)
        .then (res) ->
          if !response.newBillableGuests
            response.newBillableGuests = res
          else
            response.availableLicenseCount = if res.availableLicenseCount == null
                Infinity
              else
                res.availableLicenseCount
          Promise.resolve(response)
        .error ->
          Promise.resolve([])
      batcher.send().then ->
        response
    else
      hasBillableGuestsFeature = org?.isFeatureEnabled('multiBoardGuests')

      if hasBillableGuestsFeature
        ApiPromise
          url: "/1/organizations/#{org.id}/newBillableGuests/#{@id}"
          type: 'get'
          background: true
        .then (response) ->
          newBillableGuests: response
          availableLicenseCount: Infinity
      else
        Promise.resolve
          newBillableGuests: []
          availableLicenseCount: Infinity

  shouldRenderPluginSuggestionSection: (idPlugin) ->
    if !@editable()
      return false
    if @isPluginEnabled(idPlugin)
      return false
    if @isEnterpriseBoard() && !@getEnterprise()?.isPluginAllowed(idPlugin)
      return false

    return !@getPluginDataByKey(idPlugin, 'board', 'private', 'dismissedSection', false)

  getPaidStatus: ->
    if @isEnterpriseBoard()
      return 'enterprise'
    else if @getOrganization()?.isBusinessClass()
      return 'bc'
    else
      return 'free'

  countDueDates: ->
    return @listList.reduce((acc, list) ->
      acc + list.openCards().filter((card) -> card.get('due')?).length
    , 0)

  shouldRenderAutoEnableCalendarPopover: ->
    if !@isPowerUpEnabled('calendar')
      return false
    if !@editable()
      return false
    if featureFlagClient.get('ecosystem.auto-enable-calendar-popover', 'none') == 'none'
      return false

    # check if we've auto-enabled the calendar
    dateAutoEnabled = @getPluginDataByKey(
      CALENDAR_POWER_UP_ID,
      'board',
      'shared',
      'dateAutoEnabled',
      null
    )
    if !dateAutoEnabled
      return false

    # check if this user has seen the popover yet
    seenPopover = Auth.me().getPluginDataByKey(
      CALENDAR_POWER_UP_ID,
      'member',
      'private',
      'seenPopover',
      false
    )
    if seenPopover
      return false

    # some users might have the old seenPopover, which was in board plugin data
    # so check for the old one and migrate it to member plugin data if needed
    # can probably be removed once calendar auto enablement is fully rolled out
    oldSeenPopover = @getPluginDataByKey(
      CALENDAR_POWER_UP_ID,
      'board',
      'private',
      'seenPopover',
      false
    )
    if oldSeenPopover
      Auth.me().setPluginDataByKey(
        CALENDAR_POWER_UP_ID,
        'member',
        'private',
        'seenPopover',
        true
      )
      return false

    return true

module.exports = Board
